import { replaceSpacesWithUnderscores } from "@compass/core";
import { Column } from "devextreme-react/data-grid";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

import { DevExpressReport } from "components";
import "moment-timezone";

export const StudentParticipationByLep = (props: { title: string; response: number | undefined }) => {
  const appTenantName = useSelector((state: RootState) => state.app.tenantName);

  const onExporting = () => {
    return {
      header: props.title,
      filename: replaceSpacesWithUnderscores(props.title),
      tenantName: appTenantName,
    };
  };

  return (
    <DevExpressReport
      title={props.title}
      dataSource={[{ label: "Students with Limited English Proficiency", count: props.response }]}
      exportFormats={["pdf", "excel", "csv"]}
      onExporting={onExporting}
      fullPageSize
      showColumnChooser={false}
    >
      <Column dataField="label" caption="" />
      <Column dataField="count" caption="Number of Unduplicated Students" />
    </DevExpressReport>
  );
};
